"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoMultipleCheckboxQuestionWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var InfoQuestionWrapper_1 = require("../components/infoQuestion/InfoQuestionWrapper");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../Types");
var InfoMultipleCheckboxQuestionWidget = /** @class */ (function (_super) {
    __extends(InfoMultipleCheckboxQuestionWidget, _super);
    function InfoMultipleCheckboxQuestionWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.checkboxLabels = _this.getSetting("checkboxLabels", undefined);
        _this.checkboxInteractionFields = _this.getSetting("checkboxInteractionFields", undefined);
        _this.checkboxToField = new Map();
        _this.handleOnChange = function (event) {
            var areCheckedStatus = _this.state.areCheckedStatus;
            var oneCheckedStatus = areCheckedStatus.get(event.target.name);
            areCheckedStatus.set(event.target.name, !oneCheckedStatus);
            if (oneCheckedStatus) {
                _this.props.onStateChange(_this.checkboxToField.get(event.target.name), undefined);
            }
            else {
                _this.props.onStateChange(_this.checkboxToField.get(event.target.name), true);
            }
            _this.validateInternal(!oneCheckedStatus);
            _this.changelogRecorder.recordQuestion("change", _this.props);
        };
        var areCheckedStatus = new Map();
        if (_this.checkboxLabels && _this.checkboxInteractionFields && (_this.checkboxInteractionFields.length === _this.checkboxLabels.length)) {
            _this.checkboxLabels.forEach(function (element, index) {
                _this.bindFromField(_this.checkboxInteractionFields[index])
                    ? areCheckedStatus.set("checkbox-".concat(index), true)
                    : areCheckedStatus.set("checkbox-".concat(index), false);
                _this.checkboxToField.set("checkbox-".concat(index), _this.checkboxInteractionFields[index]);
            });
        }
        else {
            throw Error("".concat(_this.props.question.type, " widget missing equal number of 'checkboxLabels' and 'checkboxInteractionFields' settings"));
        }
        _this.state = {
            areCheckedStatus: areCheckedStatus
        };
        return _this;
    }
    InfoMultipleCheckboxQuestionWidget.prototype.render = function () {
        var label = this.props.question.label ? (0, jsx_runtime_1.jsx)("label", { children: this.props.question.label }) : this.renderHtml(this.getSetting("labelHtml"));
        var info = this.renderHtml(this.getSetting("infoHtml") || "");
        return ((0, jsx_runtime_1.jsxs)(InfoQuestionWrapper_1.InfoQuestionWrapper, { label: label, infoType: this.getSetting("infoType"), info: info, infoTitle: this.getSetting("infoTitle"), children: [this.renderInputField(), this.renderValidationResult()] }));
    };
    InfoMultipleCheckboxQuestionWidget.prototype.renderInputField = function () {
        var _this = this;
        return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", { className: "falcon-checkbox form-group ".concat(this.getSetting("cssClass", "")), children: __spreadArray([this.props.question.label && (0, jsx_runtime_1.jsx)("label", { className: "fs-18", children: this.props.question.label })], this.checkboxLabels.map(function (checkboxLabel, index) { return ((0, jsx_runtime_1.jsx)("div", { className: "d-flex", children: (0, jsx_runtime_1.jsxs)("div", { className: "form-check mr-3", children: [(0, jsx_runtime_1.jsx)("input", { className: "custom-control-input ".concat(_this.state.areCheckedStatus.get("checkbox-".concat(index))), type: "checkbox", "aria-label": _this.getSetting("ariaLabel", ""), onChange: _this.handleOnChange, name: "checkbox-".concat(index), id: "checkbox-".concat(index), checked: _this.state.areCheckedStatus.get("checkbox-".concat(index)) }), (0, jsx_runtime_1.jsxs)("label", { className: "custom-control-label", htmlFor: "checkbox-".concat(index), children: [(0, jsx_runtime_1.jsx)("div", { className: "checkbox-big" }), (0, jsx_runtime_1.jsx)("div", { className: "checkbox-label", children: (0, jsx_runtime_1.jsx)("p", { children: (0, jsx_runtime_1.jsx)("span", { children: checkboxLabel }) }) })] })] }) }, index)); }), true) }) }));
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], InfoMultipleCheckboxQuestionWidget.prototype, "changelogRecorder", void 0);
    return InfoMultipleCheckboxQuestionWidget;
}(plugin_journey_1.QuestionWidgetBase));
exports.InfoMultipleCheckboxQuestionWidget = InfoMultipleCheckboxQuestionWidget;
//# sourceMappingURL=InfoMultipleCheckboxQuestionWidget.js.map